import { fetchCrowdExpressions } from 'api/crowdExpressions';
import CrowdExpressionList from './components/CrowdExpressionList';
import RecordringForm from './components/RecordingForm';
import { useEffect, useState } from 'react';

const MakanCondolence = () => {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isActive = true;

    const loadTracks = async () => {
      try {
        setLoading(true);
        setError(null);

        const data = await fetchCrowdExpressions();

        if (isActive) {
          setTracks(data);
        }
      } catch (err) {
        if (isActive) {
          setError(
            err instanceof Error ? err.message : 'خطا در دریافت اطلاعات',
          );
          setTracks([]);
        }
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };

    loadTracks();

    return () => {
      isActive = false;
    };
  }, []);

  return (
    <div className="relative isolate flex min-h-screen flex-col items-center bg-[#010305] p-6 text-[#E6E6E6] direction-rtl [font-family:var(--font-fa)]">
      <h2 className="mb-4 text-2xl font-semibold leading-tight text-white">
        تنها صداست که می‌ماند
      </h2>

      {loading && (
        <p className="w-full max-w-5xl text-center text-sm text-white/70">
          در حال بارگذاری...
        </p>
      )}

      {!loading && error && (
        <p className="w-full max-w-5xl text-center text-sm text-red-400">
          {error}
        </p>
      )}

      {!loading && !error && <CrowdExpressionList items={tracks} />}

      <hr className="my-8 w-full max-w-5xl border-0 border-t border-white/10" />

      <h2 className="mb-4 text-2xl font-semibold leading-tight text-white">
        همدلی در ثبت صدا
      </h2>

      <RecordringForm />
    </div>
  );
};

export default MakanCondolence;
